import { Analytics, logEvent, setUserId, setUserProperties as _setUserProperties } from "firebase/analytics";

export class FirebaseAnalytics {
  constructor(private analytics: Analytics) {}

  logEvent(name: string, params?: Record<string, any>) {
    try {
      logEvent(this.analytics, name, params);
    } catch (e) {
      console.error("FirebaseAnalytics logEvent error", e);
    }
  }

  setUserId(userId: string) {
    try {
      setUserId(this.analytics, userId);
    } catch (e) {
      console.error("FirebaseAnalytics setUserId error", e);
    }
  }

  setUserProperties(props: Record<string, any>) {
    try {
      _setUserProperties(this.analytics, props);
    } catch (e) {
      console.error("FirebaseAnalytics setUserProperties error", e);
    }
  }

  pageView(title: string, path: string) {
    this.logEvent("page_view", { page_title: title, page_path: path });
  }
}
